import React from 'react';
import { motion } from 'framer-motion';
export function Agitation() {
  return <section className="py-20 px-4 bg-brand-navy text-white relative overflow-hidden" data-id="element-15">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 leading-tight" data-id="element-18">
            El problema no es que no te importe tu perro.{' '}
            <span className="text-brand-gold" data-id="element-19">
              El problema es que nadie te lo explicó de forma simple.
            </span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300" data-id="element-20">
            <p data-id="element-21">Hay miles de artículos sobre alimentación canina.</p>
            <p data-id="element-22">Algunos dicen que puedes dar frutas. Otros dicen que no.</p>
            <p data-id="element-23">
              Algunos dicen que el pollo cocido es ideal. Otros dicen que puede
              causar problemas.
            </p>
            <p className="font-medium text-white" data-id="element-24">
              Y tú, en medio de toda esa información, terminas sin saber qué
              creer.
            </p>

            <div className="w-16 h-1 bg-brand-orange mx-auto my-8 rounded-full" data-id="element-25"></div>

            <p data-id="element-26">Así que mejor no arriesgas.</p>
            <p data-id="element-27">
              Y tu perro sigue comiendo lo mismo de siempre, todos los días.
            </p>
            <p data-id="element-28">Mientras tanto, sabes que podrías darle algo más.</p>
            <p data-id="element-29">Algo casero. Algo con ingredientes que tú mismo elegiste.</p>
            <p className="text-brand-gold font-semibold text-2xl mt-8" data-id="element-30">
              Pero sin una guía clara, simple y confiable, ese momento nunca
              llega.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-31"></div>
    </section>;
}